import { render, staticRenderFns } from "./RelNps.vue?vue&type=template&id=39983ca0&scoped=true"
import script from "./RelNps.vue?vue&type=script&lang=js"
export * from "./RelNps.vue?vue&type=script&lang=js"
import style0 from "./RelNps.vue?vue&type=style&index=0&id=39983ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39983ca0",
  null
  
)

export default component.exports